<template>
  <div class="oauth-callback">
    <div class="loading-container">
      <div class="spinner"></div>
      <p v-if="!error">{{ message }}</p>
      <div v-else class="error-container">
        <p class="error">{{ error }}</p>
        <router-link to="/login" class="btn">Back to Login</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import axios, { formatApiErrorMessage } from "@/axios";

export default {
  name: "OAuthCallback",
  data() {
    return {
      message: "Completing sign in...",
      error: null,
    };
  },
  async mounted() {
    const token = this.$route.query.token;
    const errorParam = this.$route.query.error;

    if (errorParam) {
      this.error = "Authentication failed. Please try again.";
      return;
    }

    if (!token) {
      this.error = "No authentication token received.";
      return;
    }

    try {
      // Store the token
      localStorage.setItem("token", token);
      
      // Fetch user info
      this.message = "Loading your account...";
      const response = await axios.get("/api/auth/me", {
        headers: { Authorization: `Bearer ${token}` }
      });

      const user = response.data.user;
      
      // Commit to Vuex store
      this.SET_AUTH({ user, token });
      
      this.message = `Welcome${user.firstName ? `, ${user.firstName}` : ""}!`;
      
      // Short delay to show welcome message
      setTimeout(() => {
        this.$router.push("/dashboard");
      }, 500);
    } catch (err) {
      console.error("OAuth callback error:", err);
      this.error = formatApiErrorMessage(err, "Failed to complete sign in. Please try again.");
      localStorage.removeItem("token");
    }
  },
  methods: {
    ...mapActions("auth", ["loginUser"]),
    ...mapMutations("auth", ["SET_AUTH"]),
  },
};
</script>

<style scoped>
.oauth-callback {
  min-height: 100vh;
  background: #0a0a0f;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-container {
  text-align: center;
  color: #ffffff;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 3px solid rgba(139, 92, 246, 0.2);
  border-top-color: #8b5cf6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

p {
  font-size: 16px;
  color: #a1a1aa;
}

.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.error {
  color: #f87171;
  font-size: 16px;
}

.btn {
  display: inline-block;
  padding: 12px 24px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: #ffffff;
  text-decoration: none;
  border-radius: 10px;
  font-weight: 500;
  transition: all 0.2s;
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 20px rgba(139, 92, 246, 0.4);
}
</style>
